import { JSX } from 'react/jsx-runtime';

const LoadingTable = () => {
  const tableHead: JSX.Element[] = [];
  const tableBody = [];

  let headCount = 0;
  let bodyCount = 0;

  while (headCount < 4) {
    tableHead.push(
      <th key={Math.random()} className="h-[14px] py-2 px-2">
        <div className="h-[14px] p-4 animate-pulse bg-fill-secondary" />
      </th>,
    );

    headCount += 1;
  }

  while (bodyCount < 13) {
    tableBody.push(bodyCount);

    bodyCount += 1;
  }

  return (
    <table className="table-fixed w-full">
      <thead>
        <tr>
          <th className="h-[14px] w-[14px]">
            <div className="h-[14px] w-[14px] animate-pulse bg-fill-secondary" />
          </th>
          {tableHead.map((th) => th)}
        </tr>
      </thead>
      <tbody>
        {tableBody.map(() => (
          <tr key={Math.random()}>
            <td className="h-[14px] w-[14px]">
              <div className="h-[14px] w-[14px] animate-pulse bg-fill-secondary" />
            </td>
            {tableHead.map(() => (
              <td key={Math.random()} className="h-[14px] px-2 py-1">
                <div className="h-[14px] animate-pulse bg-fill-secondary p-4" />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default LoadingTable;
